"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _wrapWords = _interopRequireDefault(require("./wrapWords"));
var _typesetter = _interopRequireDefault(require("./typesetter"));
var _generateGlyphs = _interopRequireDefault(require("./generateGlyphs"));
var _resolveYOffset = _interopRequireDefault(require("./resolveYOffset"));
var _preprocessRuns = _interopRequireDefault(require("./preprocessRuns"));
var _splitParagraphs = _interopRequireDefault(require("./splitParagraphs"));
var _finalizeFragments = _interopRequireDefault(require("./finalizeFragments"));
var _resolveAttachments = _interopRequireDefault(require("./resolveAttachments"));
var _applyDefaultStyles = _interopRequireDefault(require("./applyDefaultStyles"));
var _resolveTextStyles = _interopRequireDefault(require("./resolveTextStyles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A LayoutEngine is the main object that performs text layout.
 * It accepts an AttributedString and a Container object
 * to layout text into, and uses several helper objects to perform
 * various layout tasks. These objects can be overridden to customize
 * layout behavior.
 *
 * @param  {Object}  engines
 * @param  {Object}  attributed string
 * @param  {Object}  container rect
 * @param  {Object}  layout options
 * @return {Array} paragraph blocks
 */
var layoutEngine = function layoutEngine(engines, attributedString, container, options) {
  if (options === void 0) {
    options = {};
  }
  var processParagraphs = R.compose((0, _resolveYOffset.default)(engines, options), (0, _resolveAttachments.default)(engines, options), (0, _generateGlyphs.default)(engines, options), (0, _resolveTextStyles.default)(engines), (0, _wrapWords.default)(engines, options) // detects where the words can be broken from
  );
  return R.compose((0, _finalizeFragments.default)(engines, options), (0, _typesetter.default)(engines, options, container), R.map(processParagraphs), (0, _splitParagraphs.default)(engines, options), (0, _preprocessRuns.default)(engines, options), (0, _applyDefaultStyles.default)(engines, options))(attributedString);
};
var _default = exports.default = R.curryN(3, layoutEngine);